import m from "../../geodata/es2015/mongoliaHigh";
window.am4geodata_mongoliaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/mongoliaHigh.js
// module id = null
// module chunks = 